import ScholarSectionOne from "./ScholarshipSection/ScholarSectionOne";
import ScholarSectionTwo from "./ScholarshipSection/ScholarSectionTwo";

export default function Scholarship () {
    return (
        <div>
            <ScholarSectionOne />
            <ScholarSectionTwo />
        </div>
    )
}